<template>
  <div>
    <v-dialog
      v-show="createTeamDialog"
      v-model="createTeamDialog"
      persistent
      max-width="600px"
      v-scroll-lock="!createTeamDialog"
    >
      <v-card>
        <v-card-text class="justify-center pb-1 pl-8">
          <v-row class="pt-4">
            <v-col cols="9" class="d-flex align-center">
              <v-text-field
                placeholder="type team name here..."
                outlined
                dense
                name="new_team_name"
                :hide-details="true"
                v-model="teamName"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="d-flex align-center">
              <v-btn
                @click.stop="createTeam(true)"
                color="success"
                :disabled="is_empty(teamName)"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-row style="margin-left: 30px; margin-right: 30px;">
          <v-btn class="mb-5" color="error" @click="setCreateTeamDialog(false)">
            Close
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingCreateTeam" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Now processing...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import {mapState, mapMutations, mapGetters} from 'vuex'

export default {
  name: 'PurchaseTokenDialog',
  components: {},
  props: {
    createTeamDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingCreateTeam: false,
      teamName: '',
    }
  },
  methods: {
    setCreateTeamDialog(show) {
      this.$emit('setCreateTeamDialog', show)
    },
    async createTeam() {
      this.loadingCreateTeam = true
      const result = await this.postTeam(this.teamName)
      if (!result) {
        // Do nothing and continue the process.
      }
      this.teamName = ''
      this.loadingCreateTeam = false
      this.$emit('init')
      this.$emit('setCreateTeamDialog', false)
    },
  },
  computed: {},
  mounted() {},
}
</script>

<style scoped>
.v-data-table__wrapper th {
  font-size: 18px;
  color: #00bfff !important;
}
.v-text-field__details {
  display: none;
}
</style>
